import React, { FormEvent } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useLocation, } from "react-router-dom"

import loading from '../../assets/img/contact/loading.svg';

import Breadcrumb, {BreadcrumbItem} from '../../components/Breadcrumb';

import ApiService from '../../services/ApiService';
 
const ContactConfirm = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const apiService = new ApiService();

    // ボタン制御
    const [isSubmited, setSubmited] = React.useState(false);

    // 入力取得
    const formValues = {
        inquiry: (location.state?.contactValues)?location.state.contactValues.inquiry:'',
        mail: (location.state?.contactValues)?location.state.contactValues.mail:'',
        name: (location.state?.contactValues)?location.state.contactValues.name:'',
        confirm: (location.state?.contactValues)?location.state.contactValues.confirm:false
    };

    // 「修正」ボタンイベントハンドラ
    const handleBack = () => {
        navigate('/contact', { state: {contactValues: formValues}})
    }
    // 「以上の内容で送信する」ボタンイベントハンドラ
    const handleSubmit = (event:FormEvent<HTMLFormElement>) => {
        event.preventDefault(); // フォームのデフォルトの送信動作を阻止

        setSubmited(true);  // 送信済みフラグをON

        // リクエストJSON
        const json = {
            'request_inquiry': formValues?.inquiry,
            'request_name': formValues?.name,
            'request_mailaddress': formValues?.mail,
            'request_privacypolicy': (formValues?.confirm)?true:false,
        };

        // API実行
        apiService.contact(json)
            .then((res:any) => {
                // 成功時
                navigate('/complete', {replace: true});
            })
            .catch((err:Error) => {
                if (process.env.NODE_ENV === 'development') {
                    alert(err.message);
                } else {
                    alert("メール送信が失敗しました。時間をおいて再度問合せをお願いします。");
                }
            })
            .finally(() => {
                setSubmited(false);  // 送信済みフラグをOFF
            });
    }

    // パンくずリストリンク
    const breadcrumbItems:BreadcrumbItem[] = [
        {'label': 'ホーム', 'path': '/'},
        {'label': 'お問合せ', 'path':'/contact/index.html'}
    ]

    //
    return (
        <>
        <Helmet>
            <title>お問合せ：入力内容確認 | 予算書・決算書データベース</title>
        </Helmet>
        <main id="main" className="l-contents-main">
        <div className="l-contents l-contents--head">
            <div className="l-contents__inner">

            <Breadcrumb itemLists = {breadcrumbItems} />

            <div className="c-blk-head">
                <h1 className="c-heading-lv1">お問合せ：入力内容確認</h1>
            </div>
            </div>
        </div>
        <div className="l-contents l-contents--body">
            <div className="l-contents__inner">
            <div className="c-panel">

            <form className="c-form c-contact-confirm" onSubmit={handleSubmit}>

                <ol className="c-form-flow">
                    <li className="c-form-flow__step">
                        <span className="c-form-flow__step-mark">1</span>
                        <span className="c-form-flow__step-text">内容の入力</span>
                    </li>
                    <li className="c-form-flow__step" aria-current="step">
                        <span className="c-form-flow__step-mark">2</span>
                        <span className="c-form-flow__step-text">確認</span>
                    </li>
                    <li className="c-form-flow__step">
                        <span className="c-form-flow__step-mark">3</span>
                        <span className="c-form-flow__step-text">完了</span>
                    </li>
                </ol>

                <dl className="c-form-list c-form-list--confirm">
                    <div className="c-form-item">
                    <dt className="c-form-item__term">
                        <span className="c-form-item__label">お問合せ内容</span><span className="c-form-item__required">必須</span>
                    </dt>
                    <dd className="c-form-item__detail">
                        {formValues.inquiry.split('\n').map((line:string, idx:number) => (<>{line}<br/></>))}
                    </dd>
                    </div>
                    <div className="c-form-item">
                    <dt className="c-form-item__term">
                        <span className="c-form-item__label">メールアドレス</span><span className="c-form-item__required">必須</span>
                    </dt>
                    <dd className="c-form-item__detail">
                        {formValues.mail}
                    </dd>
                    </div>
                    <div className="c-form-item">
                    <dt className="c-form-item__term">
                        <span className="c-form-item__label">氏名</span>
                    </dt>
                    <dd className="c-form-item__detail">
                        {formValues.name}
                    </dd>
                    </div>
                    <div className="c-form-item">
                    <dt className="c-form-item__term">
                        <span className="c-form-item__label">プライバシーポリシー</span><span className="c-form-item__required">必須</span>
                    </dt>
                    <dd className="c-form-item__detail">
                        {(formValues.confirm)?"同意する":"チェックなし？"}
                    </dd>
                    </div>
                </dl>
                <div className="c-form__submit">
                    <button type="button" className="c-button c-button--secondary c-button--lg" onClick={handleBack} disabled={isSubmited}>修正</button>
                    <button type="submit" className="c-button c-button--lg" aria-disabled={!formValues.confirm} disabled={isSubmited}>以上の内容で送信する</button>
                    {isSubmited &&
                        <img src={loading} width={48} />
                    }
                </div>
                </form>
            </div>
            </div>
        </div>
        </main>
        </>
    )
};

export default ContactConfirm;